module.exports = __webpack_public_path__ + "static/img/LISBON_OAK.9d4256f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LISBON_OAK.jpg
// module id = nALo
// module chunks = 0